export default {
    title:{
        default: 'Platinum Service'
    }
}
